import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { toast } from "sonner";
import { slugify } from "../../lib/format";
import { Plus, Trash2, Edit2 } from "lucide-react";

const empty = { name: "", slug: "", description: "", color: "#B91C1C" };

export default function CategoriesAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/categories").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const data = { ...form, slug: form.slug || slugify(form.name) };
    try {
      if (editing) await api.patch(`/categories/${editing}`, data);
      else await api.post("/categories", data);
      toast.success("Salvo!");
      setForm(empty); setEditing(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir?")) return;
    await api.delete(`/categories/${id}`); toast.success("Excluído"); load();
  };

  const edit = (c) => { setForm(c); setEditing(c.id); window.scrollTo(0,0); };

  return (
    <AdminLayout>
      <div data-testid="admin-categories">
        <h1 className="font-serif-display text-4xl font-bold">Categorias</h1>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          <form onSubmit={submit} className="border border-zinc-300 bg-white p-4 space-y-3" data-testid="category-form">
            <h2 className="overline">{editing ? "Editar" : "Nova categoria"}</h2>
            <input type="text" placeholder="Nome" required value={form.name} onChange={e => setForm({...form, name: e.target.value, slug: editing ? form.slug : slugify(e.target.value)})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="category-name" />
            <input type="text" placeholder="Slug" value={form.slug} onChange={e => setForm({...form, slug: slugify(e.target.value)})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <textarea placeholder="Descrição" rows={3} value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <input type="color" value={form.color} onChange={e => setForm({...form, color: e.target.value})} className="w-full h-10 border border-zinc-300" />
            <button type="submit" className="bg-black text-white px-4 py-2 w-full font-sans-ui text-sm uppercase tracking-widest font-semibold" data-testid="category-submit"><Plus size={14} className="inline mr-2"/>{editing ? "Atualizar" : "Criar"}</button>
            {editing && <button type="button" onClick={() => { setForm(empty); setEditing(null); }} className="w-full text-xs text-zinc-500 underline">Cancelar</button>}
          </form>

          <div className="md:col-span-2 border border-zinc-300 bg-white">
            <table className="w-full text-sm font-sans-ui">
              <thead className="bg-zinc-100"><tr className="text-left"><th className="p-3">Nome</th><th className="p-3">Slug</th><th className="p-3">Cor</th><th className="p-3"></th></tr></thead>
              <tbody>
                {items.map(c => (
                  <tr key={c.id} className="border-t border-zinc-200" data-testid={`cat-row-${c.slug}`}>
                    <td className="p-3 font-serif-display font-semibold">{c.name}</td>
                    <td className="p-3 text-zinc-600">{c.slug}</td>
                    <td className="p-3"><span className="inline-block w-6 h-6" style={{background: c.color}}/></td>
                    <td className="p-3 flex gap-2">
                      <button onClick={() => edit(c)} className="p-1.5 border border-zinc-300"><Edit2 size={14}/></button>
                      <button onClick={() => remove(c.id)} className="p-1.5 border border-zinc-300 text-red-700"><Trash2 size={14}/></button>
                    </td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-zinc-500">Nenhuma categoria.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
